<page-loader *ngIf="!isLoaded"></page-loader>
<div class="page-section series-form-page" *ngIf="isLoaded">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" [routerLink]="['/app']">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item app-l-current-page">
					Edit Resources
				</li>
			</ul>
		</div>
	</div>

	<div class="page-section-content">
		<div class="page-section-content">
				<ng-template mat-tab-label> Import Resources </ng-template>
				<div class="form-wrapper">
					<h3>- Step 1 -</h3>
					<p>
						Download the following spreadsheet and have it filled
						out by the client.
					</p>
					<a
						href="/assets/documents/WellTrack_Resources_Template_2020.xlsx"
						>Download Template</a
					>

					<h3>- Step 2 -</h3>
					<p>
						Select the organization that you would like to create
						resources for and upload the spreadsheet.
					</p>
					<form
						novalidate
						[formGroup]="importResourceForm"
						(ngSubmit)="doSave()"
					>
						<div class="app-c-form-group">
							<label for="parentId" translate>Source Org</label>
							<div>
								<!-- <multiselect-autocomplete placeholder="Select an organization" formControlName="organizationID" [items]="multiSelOrgs" (onSelectItems)="onSelectOrgs($event)"></multiselect-autocomplete> -->
								<select
                				class="app-c-form-control"
                				id="orgId"
                				formControlName="organizationID"
                				(ngModelChange)="onSelectOrgs($event)">
                				<option [value]="null">Select an organization</option>
                				<option *ngFor="let org of organizations" [value]="org.id">
                    				{{ org.name }}
                				</option>
            					</select>
								<mat-error *ngIf="orgError !== ''">
									{{ orgError }}
								</mat-error>
								<mat-error
									*ngIf="
										orgError === '' &&
										f.organizationID.touched &&
										f.organizationID.errors?.required
									"
								>
									Please select an organization
								</mat-error>
							</div>
						</div>
						<div class="icon-input">
							<label for="resources" translate
								>Import Resources</label
							>
							<div>
								<input
									type="file"
									style="display: inline-block"
									(change)="incomingfile($event)"
									placeholder="Upload file"
									accept=".xlsx"
								/>
							</div>
							<span
								class="text-danger"
								*ngIf="
									fileError === '' &&
									f.excelFile.touched &&
									f.excelFile.errors?.required
								"
							>
								Please upload the file to import
							</span>
							<span class="text-danger" *ngIf="fileError !== ''">
								{{ fileError }}
							</span>
						</div>
						<button
							tabindex="0"
							class="btn-primary btn-bold btn"
							
						>
							Import
						</button>
					</form>
				</div>
			</div>
		<app-resource-view></app-resource-view>
	</div>
</div>
